import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column md:flex-row gutter-s3" }
const _hoisted_2 = { class: "flex-grow-1 md:flex-order-1 md:w-6" }
const _hoisted_3 = { class: "button-group-gradient button-lg w-full" }
const _hoisted_4 = { class: "flex-grow-1 md:w-6" }

import { useEasyModeForm } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';
import { SettingsForm } from '@/views/pages/liquidity/portfolios/portfolio/models/settings-form';
import Settings from '@/views/pages/liquidity/settingsModal/Settings.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { setNestedDialogOpen } from '@/composables/utils/useUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogButtons',
  emits: ["cancel", "submit", "applySettings"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'submit'): void;
  (e: 'applySettings', value: SettingsForm): void;
}), expose: any, slots: any, attrs: any }) {

const { easyModeForm, actionButtonDisabled } = useEasyModeForm();
const { state } = useStore();



const formSettings = computed(() => {
  const settingsProperty =
    easyModeForm.action === 'addLiquidity' ? 'depositSettings' : 'withdrawSettings';

  return state.portfolios[settingsProperty];
});

const onApplySettings = ({ settings }: { settings: SettingsForm }) => {
  emits('applySettings', settings);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          class: "w-full button-lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('submit'))),
          label: _ctx.$t(_unref(easyModeForm).action),
          disabled: _unref(actionButtonDisabled)
        }, null, 8, ["label", "disabled"]),
        _createVNode(Settings, {
          type: "button",
          disabled: false,
          "on-apply-settings": onApplySettings,
          formSettings: _unref(formSettings),
          onOnShowSetting: _cache[1] || (_cache[1] = ($event: any) => (_unref(setNestedDialogOpen)($event)))
        }, null, 8, ["formSettings"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "button-base w-full button-lg",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
        label: _ctx.$t('cancel')
      }, null, 8, ["label"])
    ])
  ]))
}
}

})